import apiClient from './apiClient';

export interface QueryParams {
  order_no_from?: string;
  order_no_to?: string;
  date_from?: string;     // YYYY-MM-DD
  date_to?: string;       // YYYY-MM-DD
  warehouse_from?: string;
  warehouse_to?: string;
}

export interface ReportRow {
  FD120_01: string;       // 入庫單號
  FD120_11: string;       // 入庫日期
  FD120_12: string;       // 品號
  FD120_14: string;       // 庫位代號
  warehouse_name: string; // 庫位名稱
  FD120_35: string;       // 來源庫位起始
  FD120_36: string;       // 相關日期
  FD120_37: string;       // 來源庫位結束
  FD121_02: number;       // 品項序號
  FD121_UNIT: string;     // 單位
  FD122_03: number;       // 顏色序號
  FD120_QTY: number;      // 數量
  FD120_COL: string;      // 顏色代碼
  FD120_COLN: string;     // 顏色描述
  FD120_TB: string;       // 布段備註
  source: string;         // 資料來源
}

export interface WarehouseUnitSummary {
  warehouse_code: string;
  warehouse_name: string;
  unit: string;
  total_qty: number;
}

export interface UnitSummary {
  unit: string;
  total_qty: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  warehouse_unit_summary: WarehouseUnitSummary[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d313Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d313/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d313/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
